import encryption from '@/services/encryption';

export const normalize3rdPartyCardInformation = (thirdPartyCardData, currentUser) => {
  const body = {
    billingAddress: thirdPartyCardData.billingAddress,
    cardNonce: thirdPartyCardData.token,
    cardNumberLastFour: thirdPartyCardData.cardNumberLastFour,
    cardType: thirdPartyCardData.cardType,
    nameOnCard: thirdPartyCardData.nameOnCard || `${currentUser.firstName} ${currentUser.lastName}`,
    isDefault: true
  };

  return body;
};

export const normalizeStandardCardInformation = async (cardDetails, billingAddress, merchant) => {
  const encryptedCardDetails = await encryption.encryptCardDetails({
    cardDetails,
    paymentGateway: merchant.defaultPaymentGateway,
    isSaving: true
  });

  const body = {
    billingAddress,
    cardNumber: encryptedCardDetails.encrypted.cardNumber || encryptedCardDetails.unencrypted.cardNumber,
    cardNumberLastFour: cardDetails.cardNumberLastFour,
    cardType: cardDetails.cardType,
    cvv: encryptedCardDetails.encrypted.cvv || cardDetails.cvv,
    expiration: {
      month: cardDetails.cardExpiration.month,
      year: cardDetails.cardExpiration.year
    },
    gatewayToken: encryptedCardDetails.encrypted.token,
    nameOnCard: cardDetails.nameOnCard.fullName,
    isDefault: true
  };

  return body;
};

const normalizeSavedCardRequestBody = async (paymentMethod, currentUser, merchant) => {
  const { body: thirdPartyCardData, cardDetails, billingAddress } = paymentMethod;

  switch (paymentMethod.type) {
    case 'card':
      return normalizeStandardCardInformation(cardDetails, billingAddress, merchant);
    case 'third-party-form':
      return normalize3rdPartyCardInformation(thirdPartyCardData, currentUser);
    default:
      break;
  }
};

export default normalizeSavedCardRequestBody;
